import { Trophy, CheckCircle2 } from "lucide-react";
import { Reveal } from "./Reveal";

const VALUES = ["Big Goals", "Hard Work", "Happy Clients", "Bigger Blessings"];

export const ChampSection = () => (
  <section className="relative bg-black py-20 md:py-32 overflow-hidden" data-testid="champ-section">
    <div className="absolute -top-32 right-0 w-[520px] h-[520px] rounded-full bg-[#D4AF37]/10 blur-[140px]" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
      <Reveal className="md:col-span-6 md:order-2">
        <img src="/images/champ.jpg" srcSet="/images/champ-m.jpg 760w, /images/champ.jpg 1320w" sizes="(max-width: 768px) 100vw, 50vw" loading="lazy"
          alt="CHAMP, the Baggs 2 Riches trophy mascot, celebrating Office of the Year 2026" className="w-full rounded-[1.75rem] border border-[#D4AF37]/35 purple-glow" data-testid="champ-image" />
      </Reveal>
      <div className="md:col-span-6 md:order-1">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/50 bg-[#D4AF37]/10 px-4 py-2 text-[11px] tracking-[0.2em] uppercase text-[#D4AF37]" data-testid="office-of-year-badge">
            <Trophy className="w-4 h-4" /> Office of the Year 2026
          </span>
          <p className="eyebrow mt-8 mb-4">Meet Our Company Mascot</p>
          <h2 className="text-4xl sm:text-5xl font-medium leading-[1.05]">Say hello to <span className="gold-text italic">CHAMP™</span></h2>
          <p className="mt-3 text-sm tracking-[0.18em] uppercase text-white/50">Chief Happiness And Motivational Partner</p>
          <p className="mt-6 text-white/75 font-light text-base md:text-lg leading-relaxed">
            Our trophy for being named Office of the Year became our mascot. CHAMP reminds us to keep showing up, stay consistent,
            and always go for the <span className="text-[#D4AF37] font-medium">WIN</span> — for our clients, our team and our future!
          </p>
          <blockquote className="mt-6 border-l-2 border-[#D4AF37] pl-5 font-display italic text-xl md:text-2xl text-white/90">
            “Yup, that's me! I sparkle, I hustle, I celebrate wins… and I remind you taxes pay for trophies!”
          </blockquote>
          <ul className="mt-8 grid grid-cols-2 gap-3">
            {VALUES.map((v) => (
              <li key={v} className="flex items-center gap-2 text-sm text-white/85"><CheckCircle2 className="w-4 h-4 text-[#D4AF37] shrink-0" />{v}</li>
            ))}
          </ul>
          <p className="mt-8 font-display italic text-2xl gold-text">Same Team. New Mascot. More Wins!</p>
        </Reveal>
      </div>
    </div>
  </section>
);
